
import { createSlice } from "@reduxjs/toolkit";

import {
  fetchCentralizedResumeDatabase,
  CentralizedResume,
  CentralizedResumeDatabasePagination,
} from "./centralizedResumeDatabase.thunk";

interface CentralizedResumeDatabaseState {
  resumes: CentralizedResume[];
  pagination: CentralizedResumeDatabasePagination | null;
  loading: boolean;
  error: string | null;
}

const initialState: CentralizedResumeDatabaseState = {
  resumes: [],
  pagination: null,
  loading: false,
  error: null,
};

const centralizedResumeDatabaseSlice = createSlice({
  name: "centralizedResumeDatabase",
  initialState,
  reducers: {
    clearCentralizedResumeDatabase: (state) => {
      state.resumes = [];
      state.pagination = null;
      state.error = null;
      state.loading = false;
    },
    clearCentralizedResumeDatabaseError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchCentralizedResumeDatabase.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    );

    builder.addCase(
      fetchCentralizedResumeDatabase.fulfilled,
      (state, action) => {
        state.loading = false;
        state.resumes = action.payload.resumes ?? [];
        state.pagination = action.payload.pagination ?? null;
        state.error = null;
      }
    );

    builder.addCase(
      fetchCentralizedResumeDatabase.rejected,
      (state, action) => {
        state.loading = false;
        state.error =
          action.payload ??
          action.error.message ??
          "Failed to fetch centralized resume database.";
      }
    );
  },
});

export const {
  clearCentralizedResumeDatabase,
  clearCentralizedResumeDatabaseError,
} = centralizedResumeDatabaseSlice.actions;

export default centralizedResumeDatabaseSlice.reducer;
